import React from 'react';
import MenuList from '@mui/material/MenuList';

import LegacyMenuItem from '../../Menu/LegacyMenuItem';
import { Popover } from '../../Popover';
import Typography from '../../Typography';

const BreadcrumbExpand = ({ children }: { children: Array<React.ReactNode> }) => {
  return (
    <Popover>
      <Popover.Button>
        <Typography className="text-text-secondary hover:text-text-primary" variant="body-long-01">
          ...
        </Typography>
      </Popover.Button>
      <Popover.Content>
        <MenuList className="p-8">
          {children && Array.isArray(children)
            ? children.map((child, i) => <LegacyMenuItem key={i} id={i.toString()} label={child} />)
            : children}
        </MenuList>
      </Popover.Content>
    </Popover>
  );
};

export default BreadcrumbExpand;
